import React, { useEffect, useState } from 'react'

import { Checkbox, useTheme } from '@mui/material'
import TableCell from '@mui/material/TableCell'

import {
  addAllTradesOnPageToMassFill,
  removeAllTradesOnPageToMassFill,
} from '../../pages/TradingLog'
import { useAppDispatch, useAppSelector } from '../../store/hooks'

export const TradingLogHeaderCellSelect = () => {
  const { palette, spacing } = useTheme()
  const dispatch = useAppDispatch()
  const {
    trades,
    selectedTrades,
    pagination: { page },
  } = useAppSelector((state) => state.tradingLog)

  const allTradesOnPage = trades.map((trade) => ({
    id: Number(trade.id),
    journalingCompletion: Number(trade.journalingCompletion),
  }))

  const checked = trades.every(
    (trade) => !!selectedTrades.find((selectedTrade) => selectedTrade.id === Number(trade.id)),
  )

  const hasSomeCheckedTrades = trades.some((trade) =>
    selectedTrades.find((selectedTrade) => selectedTrade.id === Number(trade.id)),
  )

  const calcIndeterminate = () => hasSomeCheckedTrades && selectedTrades.length > 0 && !checked
  const [isIndeterminate, setIsIndeterminate] = useState(calcIndeterminate())

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      dispatch(addAllTradesOnPageToMassFill(allTradesOnPage))
    } else {
      dispatch(removeAllTradesOnPageToMassFill(allTradesOnPage))
    }
  }

  useEffect(() => {
    setIsIndeterminate(calcIndeterminate())
  }, [page, selectedTrades, trades])

  return (
    <TableCell
      sx={{
        color: palette.grey[700],
        fontSize: 13,
        fontWeight: 800,
        textAlign: 'right',
        padding: spacing(1.125),
        flexDirection: 'row-reverse',
        borderBottom: 'none',
      }}
    >
      <Checkbox checked={checked} indeterminate={isIndeterminate} onChange={handleChange} />
    </TableCell>
  )
}
